const { eventCategory, eventInitiator, eventType } = require('./print');

function getActiveDeviceEventBody(platoon, deviceKind, list, eventLookAheadSeconds = 0, startTimeSinceEpoch = null) {
  if (typeof platoon !== 'object' || platoon === null || typeof deviceKind !== 'string' || !Array.isArray(list) || typeof eventLookAheadSeconds !== 'number') {
    return null;
  }
  const { parentPlatoons = [] } = platoon;
  if (typeof startTimeSinceEpoch !== 'number' || startTimeSinceEpoch < 0) {
    const startTimeLte = new Date();
    startTimeLte.setSeconds(startTimeLte.getSeconds() + eventLookAheadSeconds);
    startTimeSinceEpoch = startTimeLte.getTime();
  }
  const candidates = list
    .filter((item) => (item.type === deviceKind || ((item.type === 'evse' || item.type === 'circuitBreaker') && deviceKind === 'evse-circuitBreaker')))
    .filter((item) => Date.parse(item.startTime) <= startTimeSinceEpoch);

  if (candidates.length === 0) {
    return null;
  }

  return candidates
    // adds platoon rank
    .map((event) => {
      const out = { ...event, rank: 0 };
      if (event.parentEventLogId != null) {
        const { platoonId } = event.parentEventLog;
        const { hops } = parentPlatoons.find(({ parentPlatoonId }) => parentPlatoonId === platoonId);
        out.rank = hops + 1;
      }
      return out;
    })
    // order by the rank
    .sort(({ rank: a }, { rank: b }) => a - b)
    // get the lowest rank
    .reduce((events, next) => {
      if (events.length === 0) {
        return [next];
      }
      if (events[0].rank === next.rank) {
        return events.concat(next);
      }
      return events;
    }, [])
    // order by initiator, i.e. null, platoon-event, schedule
    .sort(({ initiator: a }, { initiator: b }) => {
      function order(initiator) {
        switch (initiator) {
          case 'schedule':
            return 2;
          case 'platoon-event':
            return 1;
          default:
            return 0;
        }
      }
      return order(a) - order(b);
    })
    // pass the ones with initiator matching the first
    .reduce((events, next) => {
      if (events.length === 0) {
        return [next];
      }
      if (events[0].initiator === next.initiator) {
        return events.concat(next);
      }
      return events;
    }, [])
    // sort by start time, latest first
    .sort((a, b) => Date.parse(b.startTime) - Date.parse(a.startTime))
    // pass only the ones with the latest start time
    .reduce((events, next) => {
      if (events.length === 0) {
        return [next];
      }
      if (Date.parse(events[0].startTime) === Date.parse(next.startTime)) {
        return events.concat(next);
      }
      return events;
    }, [])
    // order by createdAt
    .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    // remove the rank
    .map((event) => {
      const out = { ...event };
      delete out.rank;
      return out;
    })[0];
}

module.exports = {
  containsActive: (events) => events.find((event) => !event.canceled && event.started) !== undefined,
  containsNoActive: (events) => events.find((event) => !event.canceled && !event.started) === undefined,
  containsUpcoming: (events) => events.find((event) => !event.canceled && !event.started) !== undefined,
  containsNoUpcoming: (events) => events.find((event) => !event.canceled && !event.started) === undefined,
  eventCategory,
  eventInitiator,
  eventType,
  getActiveDeviceEventBody,
};
